const EmailDirective = angular.module("EmailDirective", []).directive("pwEmail", email);

function email() {
    return {
        require: "ngModel",
        restrict: "A",
        priority: 1000,
        link: function (scope, element, attr, ctrl) {
            var pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@([a-zA-Z0-9\-'\`]+[\.])+[a-zA-Z]{2,}$/;

            ctrl.$validators.emailFormat = function (value) {
                return value === "" || value === null ? true : pattern.test(value);
            };
        }
    };
}
export default EmailDirective;
